export default "__VITE_ASSET__DAxKz3w4__"